import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import '../styles/keyboardShortcutsModal.scss';
import ButtonComponent from './ButtonComponent';
import CustomScrollbar from './CustomScrollbar';
import Popup from './Popup';
import { t } from 'i18next';
import { getImageSrc } from '../helper/imageBlobCache';
// Detect Mac at module scope. Falls back to PC labels for unknown platforms.
var isMac = typeof navigator !== 'undefined' &&
    /Mac|iPad|iPhone|iPod/.test(navigator.platform);
var SHORTCUTS = [
    { pc: 'Shift + Click', mac: 'Shift + Click', label: 'text.selectMultiple' },
    { pc: 'Ctrl + Alt + T', mac: 'Ctrl + Opt + T', label: 'text.addTextBox' },
    { pc: 'Ctrl + Alt + C', mac: 'Ctrl + Opt + C', label: 'text.duplicateSelected' },
    { pc: 'Delete / Backspace', mac: 'Delete / Backspace', label: 'text.deleteSelected' },
    { pc: 'Ctrl + Shift + K', mac: 'Ctrl + Shift + K', label: 'text.enterShareCode' },
    // { pc: 'Ctrl + Alt + S', mac: 'Cmd + Alt + S', label: 'text.share' },
    // { pc: 'Ctrl + Shift + F', mac: 'Ctrl + Shift + F', label: 'text.save' },
    { pc: 'Ctrl + Shift + L', mac: 'Ctrl + Shift + L', label: 'text.toggleLanguage' },
    { pc: 'Ctrl + Alt + I', mac: 'Ctrl + Opt + I', label: 'text.openHelpForSelected' },
    // { pc: 'Ctrl + S', mac: 'Cmd + S', label: 'text.saveYourWork' },
    { pc: 'Ctrl + =', mac: 'Cmd + =', label: 'text.zoomIn' },
    { pc: 'Ctrl + -', mac: 'Cmd + -', label: 'text.zoomOut' },
    { pc: 'Ctrl + Shift + /', mac: 'Ctrl + Shift + /', label: 'text.toggleShortcuts' },
];
var KeyboardShortcutsModal = function (props) {
    var setShowModal = props.setShowModal, showModal = props.showModal;
    var triggerRef = useRef(document.activeElement);
    var closeBtnRef = useRef(null);
    var titleRef = useRef(null);
    var closeModal = function () { return setShowModal(false); };
    // Restore focus to the element that opened the modal
    useEffect(function () {
        return function () {
            var el = triggerRef.current;
            if (el) {
                setTimeout(function () { return el.focus(); }, 0);
            }
        };
    }, []);
    // titleRef is passed as initialFocusRef to Popup — no manual focus needed here
    // Popup already handles Escape via its own onKeyDown — no duplicate
    // listener needed. Removed the separate document-level Escape handler
    // to avoid double-close or race conditions.
    return (_jsx(Popup, { isOpen: showModal, onClose: closeModal, ariaLabel: t('text.keyboardShortcuts'), ariaLabelledBy: "shortcutsModalTitle", className: "keyShortCutsPanel", initialFocusRef: titleRef, children: _jsxs("div", { className: "shortcutsModalContainer", children: [_jsx("h2", { className: "title", id: "shortcutsModalTitle", ref: titleRef, tabIndex: -1, children: t('text.keyboardShortcuts') }), _jsx("div", { className: "srOnly", children: _jsx("ul", { "aria-label": t('text.keyboardShortcuts'), children: SHORTCUTS.map(function (_a) {
                            var pc = _a.pc, mac = _a.mac, label = _a.label;
                            var displayKey = isMac ? mac : pc;
                            return (_jsxs("li", { children: [t(label), ": ", displayKey] }, displayKey));
                        }) }) }), _jsx(CustomScrollbar, { className: "shortcutsScrollbar", direction: "vertical", tabIndex: -1, children: _jsx("div", { className: "shortcutsList", "aria-hidden": "true", children: _jsx("div", { children: SHORTCUTS.map(function (_a) {
                                var pc = _a.pc, mac = _a.mac, label = _a.label;
                                var displayKey = isMac ? mac : pc;
                                return (_jsxs("div", { className: "shortcutRow", children: [_jsx("div", { className: "shortcutKey", children: _jsx("div", { children: displayKey }) }), _jsx("div", { className: "shortcutLabel", children: t(label) })] }, displayKey));
                            }) }) }) }), _jsx(ButtonComponent, { type: "textType1", text: t('text.close'), defaultCSS: "closeBtn", normalCSS: "normalBtn", clickHandler: closeModal, ariaLabel: t('text.closeKeyboardShortcuts'), reference: closeBtnRef }), _jsx("div", { className: "footerModal", "aria-hidden": "true", children: _jsx("img", { src: getImageSrc('./assets/images/popupColorPatch.svg'), tabIndex: -1, alt: "" }) })] }) }));
};
export default KeyboardShortcutsModal;
